import React from 'react';
import classNames from 'classnames';
import { Card as PropulsionCard } from 'propulsion-rc-v2';
import './Card.scss';

export default function Card({
  className = undefined,
  rounded = false,
  circled = false,
  elevation = undefined,
  spacing = undefined,
  color = undefined,
  children,
  ...props
}) {
  const spacingClass = spacing ? `u-spacing-${spacing}` : '';
  const colorClass = color ? `Card-color--${color}` : '';
  return (
    <PropulsionCard
      className={classNames(
        {
          'u-rounded': rounded,
          'u-circled': circled,
          [`u-elevation-${elevation}`]: typeof elevation !== 'undefined',
          [spacingClass]: spacingClass.length > 0,
          [colorClass]: colorClass.length > 0,
        },
        className,
      )}
      {...props}
    >
      {children}
    </PropulsionCard>
  );
}

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/shared_modules/local-propulsion/core/styles.scss');